import React, {useContext} from "react" ;
import queryString from "query-string";
import {useLocation} from "react-router-dom";
import GlobalContext, {useGlobalContext} from "root/contexts/GlobalContext";
import {getDefaultChildImage} from "root/DataFunctions/PageContentRoles";
import './ContactAppBodyHeader.scss';
import {getDocumentUrl} from "root/DataFunctions/CommonDataFns";
import {UserTypes} from "root/DataFunctions/Constants";

const ContactAppBodyHeader= (props) =>
{
    const { userType } = useGlobalContext() ;

    const {search} = useLocation()
    const queryParams = queryString.parse(search);
    const contact_ut_id = Number(props.contact_user_type_id);

    const hide_surname = (userType === UserTypes.BIRTH_PARENT || userType === UserTypes.OTHER)
    && (contact_ut_id === UserTypes.FOSTER_PARENT || contact_ut_id === UserTypes.FOREVER_PARENT) ? true : false;

    const getChildImage = () =>
    {
        const url = hide_surname || props.document_id === null ? '/images/defaultPerson.jpg' : getDocumentUrl(props.document_id) ;

        return url
    }

    const displayHeader = () =>
    {
        switch (queryParams.type)
        {
            case 'posts':
                return <h4 className="title">Posts</h4>
                break;
        }
    }

    const headerStyle = {
        display: 'grid',
        gridTemplateColumns: '7rem auto',
        alignItems: 'center'
    } ;

    return (
        <div className="dt-module__header d-none d-md-flex">

            <div style={ headerStyle} className="child-menu-item">
                <img alt="image" src={getChildImage()} width='50px' align="left"/>
                <span>{props.contact_known_as} </span>

            </div>

            <div className="child-menu-item">
                {displayHeader()}
            </div>

            {/*<AppBodyNotificationDropdown />*/}

        </div>
    ) ;
}

export default ContactAppBodyHeader;
